export default __webpack_public_path__ + "static/media/users-purple.a5e29367.svg";